function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconX = function SvgIconX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1190 1190"
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-238.973 -16.202)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 834.28,
    cy: 610.6,
    r: 481.33,
    style: {
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m485.39 356.79 230.07 307.62-231.52 250.11h52.11l202.7-218.98 163.77 218.98h177.32L836.82 589.6l215.5-232.81h-52.11L813.54 558.46 662.71 356.79zm76.63 38.38h81.46l359.72 480.97h-81.46z",
    style: {
      fill: "#fff"
    },
    transform: "translate(52.39 -25.059)"
  })));
};
export default SvgIconX;